import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetActivitiesSummaryByTaskUseCaseInterface } from 'domain/usecases';

export class RemoteActivitiesSummaryByTask
  implements GetActivitiesSummaryByTaskUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetActivitiesSummaryByTaskUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetActivitiesSummaryByTaskUseCaseInterface.Params,
  ): Promise<GetActivitiesSummaryByTaskUseCaseInterface.Result> {
    const { reportType, ...rest } = params;

    const requestUrl = generateUrl(`${this.url}/${reportType}`, rest as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: `${requestUrl}`,
      responseType: params.reportType === '2' ? 'json' : 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
